const FooterText = 
<div>
    <strong>
        Dr. Akshay Murthy
    </strong>
    <br/>
        Associate Scientist, Fermi National Accelerator Laboratory
    <br/>
         Superconducting Quantum Materials and Systems (SQMS) division
    <br/>
        Batavia, IL, 60510, USA
    <br/>
        amurthy@fnal.gov
</div>

export default FooterText;